'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewListComponent = exports.productOverviewListComponent = {
    template: require('./product-overview-list.html'),
    bindings: {
        products: '<',
        errorOccurred: '<',
        context: '<',
        viewMode: '=',
        parentState: '<',
        onChangeQuantity: '&',
        filter: '<',
        isOrderByDescending: '<',
        getProductDiscounts: '&',
        searchText: '<'
    },
    controllerAs: 'vm',
    controller: function productOverviewListController() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getProductDiscountsList = getProductDiscountsList;
        vm.changeQuantity = changeQuantity;

        function init() {
            // angular.forEach(vm.products, (p) => { 
            //     Analytics.addImpression(p.id, p.name, vm.context, p.brand, '', '', '', p.price, { sellerId: p.sellerId, sellerName: p.sellerName, discountId: p.discountId });
            // });
            vm.productsWithInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity > 1;
            });
            vm.productsWithoutInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity === 1;
            });
            // Analytics.pageView();
        }

        function changeQuantity($event) {
            vm.onChangeQuantity({ $event: $event });
        }

        /* get the product discounts */
        function getProductDiscountsList(product) {
            return vm.getProductDiscounts({ product: product });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-overview-list.js
// module id = 978
// module chunks = 0